export default {
  mutations: {
    SET_PAYINS: 'SET_PAYINS',
    SET_LOADING: 'SET_LOADING',
  },
  getters: {
    GET_PAYINS: 'GET_PAYINS',
    GET_PAYIN_STATUS: 'GET_PAYIN_STATUS',
    GET_LOADING: 'GET_LOADING',
    GET_PAYINS_PAGINATION: 'GET_PAYINS_PAGINATION',
  },
  actions: {
    PAYIN_LIST: 'PAYIN_LIST',
    PAYIN_STATUS_LIST: 'PAYIN_STATUS_LIST',
    PAYIN_PAGINATION: 'PAYIN_PAGINATION',
    PAYINS_LOADING: 'PAYINS_LOADING',
  },
};
